import { useHMSRecorder } from "../hms";
import { useLivekitRecorder } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderRecorder = () =>
  useProviderHook({
    hms: useHMSRecorder,
    livekit: useLivekitRecorder,
  })();
